import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import uuid from "react-uuid";
import { Modal } from "bootstrap";
import Ax from "../../../../components/hoc/Ax";
import { ToastContainer, toast } from "react-toastify";
import { HRM_API_BASE_URL_2, IAM_API_BASE_URL_2 } from "../../../../services/TapApiUrls";
import HttpAPICall from "../../../../services/HttpAPICall";
import Loader from "../../../../components/ui/Loader/Loader";
import TapIcon from "../../../../services/TapIcon";
import swal from "sweetalert";
import AppBaseComponent from "../../../../components/AppBaseComponent";
import AdditionalAttribute from "../../AdditionalAttribute";
import General from "./General";

class EmpWorkLog extends AppBaseComponent {
    constructor(props) {
        super(props);

        this.worklogTypeFormDataInit = {
            id: null,
            name: "",
            key: "",
            availability: "2",
        };
        this.state = {
            workLogTypeLoading: false,
            workLogTypeFormSubmiting: false,
            workLogTypes: [],
            worklogType: null,
            worklogTypeFormData: { ...this.worklogTypeFormDataInit },

        };
        this.workLogTypeEditModalId = uuid();
        this.workLogTypeUrl = HRM_API_BASE_URL_2;
    }

    componentDidMount = () => {
        this.workLogTypeEditModal = new Modal(
            document.getElementById(this.workLogTypeEditModalId),
            { keyboard: false, backdrop: false }
        );
        this.getWorkLogTypes();
    };


    getWorkLogTypes = () => {
        this.setState({ workLogTypeLoading: true });
        HttpAPICall.withAthorization("GET", this.workLogTypeUrl + "/work_log_type_list", this.props.access_token, {}, {}, (resp) => {
            this.setState({ workLogTypes: resp.data });
        }
        ).then(() => this.setState({ workLogTypeLoading: false }));
    };

    workLogTypeActionInit = (id = null) => {
        this.workLogTypeEditModal.show();
        let worklogType = null;
        if (id) {
            worklogType = this.state.workLogTypes.find((d) => d.id == id);
        }
        this.setState({
            worklogType: worklogType,
            worklogTypeFormData: {
                ...this.state.worklogTypeFormData,
                id: worklogType ? worklogType.id : null,
                name: worklogType ? worklogType.name : "",
                key: worklogType ? worklogType.key : "",
                availability: worklogType
                    ? worklogType.availability
                    : "2",
            },
        });
    };

    workLogTypeDeleteInit = (id = null) => {
        swal({
            title: "Delete",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            buttons: ["No", "Yes"],
        }).then((willDelete) => {
            if (willDelete) {
                this.setState({ workLogTypeLoading: true });
                HttpAPICall.withAthorization(
                    "DELETE",
                    this.workLogTypeUrl + "/work_log_type_delete/" + id,
                    this.props.access_token, {}, {}, (response) => {
                        toast.success(response.data.msg, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        this.getWorkLogTypes();
                    },
                    () => {
                        this.setState({ workLogTypeLoading: false });
                    }
                ).then(() => { });
            }
        });
    };

    workLogTypeSubmit = (e) => {
        e.preventDefault();
        this.setState({ workLogTypeFormSubmiting: true });
        if (this.state.worklogType) {
            HttpAPICall.withAthorization(
                "PUT",
                this.workLogTypeUrl + "/work_log_type_edit",
                this.props.access_token,
                {},
                this.state.worklogTypeFormData,
                (response) => {
                    toast.success(response.data.msg, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    this.workLogTypeEditModal.hide();
                    this.getWorkLogTypes();
                }
            ).then(() => this.setState({ workLogTypeFormSubmiting: false }));
        } else {
            HttpAPICall.withAthorization(
                "POST",
                this.workLogTypeUrl + "/work_log_type_add",
                this.props.access_token,
                {},
                this.state.worklogTypeFormData,
                (response) => {
                    toast.success(response.data.msg, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    this.workLogTypeEditModal.hide();
                    this.getWorkLogTypes();
                }
            ).then(() => this.setState({ workLogTypeFormSubmiting: false }));
        }
    };



    workLogTypeActionModalJsx = () => {
        return (
            <div
                className="modal fade"
                id={this.workLogTypeEditModalId}
                tabIndex="-1"
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                {this.state.worklogType ? "Edit" : "Add"} WorkLog Type
                            </h5>
                        </div>
                        <div className="modal-body">
                            <form
                                id={this.workLogTypeEditModalId + "Form"}
                                onSubmit={this.workLogTypeSubmit}
                            >
                                <div className="row mb-3">
                                    <div className="col-sm-6">
                                        <label className="form-label require">
                                            WorkLog Type Name
                                        </label>
                                        <input
                                            onChange={(e) =>
                                                this.formInputHandler(e, "worklogTypeFormData")
                                            }
                                            value={this.state.worklogTypeFormData.name}
                                            type="text"
                                            className="form-control"
                                            placeholder="WorkLog Type Name"
                                            name="name"
                                            autoComplete="off"
                                        />
                                    </div>
                                    <div className="col-sm-6">
                                        <label className="form-label require">
                                            WorkLog Type Key
                                        </label>
                                        <input
                                            onChange={(e) =>
                                                this.formInputHandler(e, "worklogTypeFormData")
                                            }
                                            value={this.state.worklogTypeFormData.key}
                                            type="text"
                                            className="form-control"
                                            placeholder="WorkLog Type Key"
                                            name="key"
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={this.state.worklogTypeFormData.availability === "1"}
                                        onChange={(e) => {
                                            this.setState({
                                                worklogTypeFormData: {
                                                    ...this.state.worklogTypeFormData,
                                                    availability: e.target.checked ? "1" : "2",
                                                },
                                            });
                                        }}
                                        id="availability"
                                    />
                                    <label
                                        className="form-check-label mx-2"
                                        htmlFor="availability"
                                    >
                                        Impact On Availability
                                    </label>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                disabled={this.state.workLogTypeFormSubmiting}
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary"
                                form={this.workLogTypeEditModalId + "Form"}
                                disabled={this.state.workLogTypeFormSubmiting}
                            >
                                Save{" "}
                                {this.state.workLogTypeFormSubmiting && (
                                    <TapIcon.FontAwesomeIcon
                                        icon={TapIcon.faSyncAlt}
                                        className="fa-spin"
                                    />
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    render = () => {
        return (
            <section className="item_view_container bg-white">
                <Helmet>
                    <title>Employee Configuration : WorkLog</title>
                </Helmet>
                <ToastContainer />
                <ul className="nav nav-tabs" id="myTab">
                    <li className="nav-item" role="downtimeTab">
                        <button className="nav-link active" id="setting-tab" type="button" data-bs-toggle="tab" data-bs-target="#tab_1" aria-controls="tab_1" role="tab" aria-selected="true">General Settings</button>
                    </li>
                    <li className="nav-item" role="downtimeTab">
                        <button
                            className="nav-link "
                            id="worklog-tab"
                            type="button"
                            data-bs-toggle="tab"
                            data-bs-target="#worklog"
                            aria-controls="worklog"
                            role="tab"
                            aria-selected="true"
                        >
                            WorkLog Type
                        </button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link " id="additional_attribute-tab" data-bs-toggle="tab" data-bs-target="#additional_attribute"
                            type="button" role="tab" aria-controls="additional_attribute" aria-selected="true">Additional Attribute
                        </button>
                    </li>
                </ul>
                <div className="tab-content" id="myTabContent">
                    <div className="tab-pane  show active" id="tab_1" role="tabpanel"
                        aria-labelledby="setting-tab">
                        <div className="tab_content_header">
                            <General afterSubmitConfiguration={() => this.setState({ configurationChanged: true })} />
                        </div>
                    </div>
                    <div className="tab-pane " id="worklog" role="tabpanel"
                        aria-labelledby="worklog-tab">
                        <div className="tab-pane" id="worklog" aria-labelledby="worklog-tab">
                            <div className="tab_content_header">
                                <div className="tab_content_wrapper mb-2">
                                    <span className="content_heading">WorkLog Types</span>
                                    <button
                                        className="btn btn-secondary btn-sm"
                                        onClick={this.workLogTypeActionInit}
                                    >
                                        <TapIcon.FontAwesomeIcon icon={TapIcon.faPlus} />
                                    </button>
                                </div>
                                <table className="table table-hover table-bordered">
                                    <thead className="table-secondary">
                                        <tr className="text-center">
                                            <th style={{ width: "5%" }}>S.No</th>
                                            <th className="text-start" style={{ width: "50%" }}>
                                                Name
                                            </th>
                                            <th style={{ width: "10%" }}>key</th>
                                            <th style={{ width: "25%" }}>Impact On availability</th>
                                            <th style={{ width: "10%" }}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.workLogTypeLoading ? (
                                            <tr>
                                                <td className="text-center" colSpan="5">
                                                    <Loader />
                                                </td>
                                            </tr>
                                        ) : (
                                            <Ax>
                                                {this.state.workLogTypes && this.state.workLogTypes.length > 0 ?
                                                    (this.state.workLogTypes.map((d, k) => {
                                                        return (
                                                            <tr key={k} className="text-center">
                                                                <td>{k + 1}</td>
                                                                <td className="text-start">
                                                                    {d.name}
                                                                </td>
                                                                <td>{d.key}</td>
                                                                <td>
                                                                    {d.availability == "1" ? "Yes" : "No"}
                                                                </td>
                                                                <td>
                                                                    <span className="dropdown">
                                                                        <button
                                                                            type="button"
                                                                            id="actionMenuButton"
                                                                            data-bs-toggle="dropdown"
                                                                            aria-expanded="false"
                                                                            className="btn"
                                                                        >
                                                                            <TapIcon.FontAwesomeIcon
                                                                                icon={TapIcon.faEllipsisV}
                                                                            />{" "}
                                                                        </button>
                                                                        <ul
                                                                            className="dropdown-menu"
                                                                            aria-labelledby="dropdownMenuButton1"
                                                                        >
                                                                            <li>
                                                                                <Link
                                                                                    className="dropdown-item"
                                                                                    role="button"
                                                                                    onClick={() =>
                                                                                        this.workLogTypeActionInit(d.id)
                                                                                    }
                                                                                >
                                                                                    Edit
                                                                                </Link>
                                                                            </li>

                                                                            <li>
                                                                                <Link
                                                                                    className="dropdown-item"
                                                                                    role="button"
                                                                                    onClick={() =>
                                                                                        this.workLogTypeDeleteInit(d.id)
                                                                                    }
                                                                                >
                                                                                    Delete
                                                                                </Link>
                                                                            </li>

                                                                        </ul>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        );
                                                    }))
                                                    : <tr>
                                                        <td className="text-center" colSpan="5">
                                                            No Record Found
                                                        </td>
                                                    </tr>
                                                }
                                            </Ax>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="tab-pane" id="additional_attribute" aria-labelledby="additional_attribute">
                        <div className="tab_content_header">
                            <div className="tab_content_header">
                                <AdditionalAttribute category="employee_worklog" />
                            </div>
                        </div>
                    </div>
                </div>

                {this.workLogTypeActionModalJsx()}
            </section>
        );
    };
}

const mapStateToProps = (state) => {
    return {
        access_token: state.auth.access_token,
    };
};

export default connect(mapStateToProps)(EmpWorkLog);
